<template>
  <div>
    <vs-popup title="사용자 검색" :active.sync="showPopup" id="alertUserSelectPopup">
      <search-nav @handleSearch="handleSearch">
        <search-select label="검색조건" :options="{items: searchTypes, default: 'name'}" v-model="search.type"/>
        <search-keyword label="키워드" v-model="search.keyword" :onClickSearch="handleSearch"/>
      </search-nav>
      <div>
        <table>
          <thead>
            <th v-if="visibleField">{{ feildTitle }}</th>
            <th>소속명</th>
            <th>부서명</th>
            <th>이름</th>
          </thead>
          <tbody>
            <tr v-for="user in userList"
                :key="user.id"
                :class="[user.disabled ? 'disabled' : '', selectUser && selectUser.id === user.id ? 'active' : '']"
                @click="onClickUser(user)">
              <td v-if="visibleField">{{ getFieldName(user.fields) }}</td>
              <td>{{ user.company ? user.company.com_name : "" }}</td>
              <td>{{ user.section }}</td>
              <td>{{ user.name }}{{ user.rank ? ` ${user.rank}` : ''}}</td>
            </tr>
          </tbody>
        </table>
        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination :total="page.lastPage ? page.lastPage : 0" v-model="page.current" @change="handleChangePage" />
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end mt-4">
        <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="showPopup = false">닫기 </vs-button>
        <vs-button color="secondary" :disabled="!selectUser" @click="onClickSelect">선택</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import KPagination from "@/components/kPagination/kPagination.vue";

import config from "/public/config";
import SearchSelect from "@/views/list/components/SearchSelect.vue";
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";

export default {
  name: "PopupSearchUser",
  components: {
    SearchKeyword,
    SearchSelect,
    SearchNav,
    KPagination,
  },
  props: {
    value: Boolean,
    disabledUserIds: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
    visibleField: { type: Boolean, default: true },
  },
  watch: {
    showPopup(value) {
      if (value) {
        this.page = {
          current: 1,
          lastPage: 1,
          perPage: 5,
        };
        this.search = { type: "", keyword: "" };
        this.selectUser = undefined;
        this.loadUsers();
      }
    },
  },
  computed: {
    feildTitle() {
      let _fieldTitle = "사업장명";
      switch (config.HOST_NAME) {
      case "nhsafe.maot.co.kr":
      case "dev-nhsafe.maot.co.kr":
        _fieldTitle = "현장명";
        break;
      }
      return _fieldTitle;
    },
    searchTypes() {
      return [
        { value: "field", text: this.feildTitle },
        { value: "company", text: "소속명" },
        { value: "section", text: "부서명" },
        { value: "name", text: "이름" },
      ];
    },
    showPopup: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      selectUser: undefined,
      search: { type: "name", keyword: "" },
      page: {
        current: 1,
        lastPage: 1,
        perPage: 5,
      },
      userList: [],
    };
  },
  mounted() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },
  methods: {
    handleSearch() {
      if (this.search.type || this.search.keyword) {
        this.page = {
          current: 1,
          lastPage: 1,
          perPage: 5,
        };
        this.loadUsers();
      }
    },
    async loadUsers() {
      if (!this.showPopup) return;

      // ========= 기본 =========
      const { current, lastPage, perPage } = this.page;
      const { type, keyword } = this.search;

      const params = { searchType: "and", page: current, perPage, projectId: this.$route.params.proj_id };
      switch (type) {
      case "field":
        params.field = keyword;
        break;
      case "company":
        params.company = keyword;
        break;
      case "section":
        params.section = keyword;
        break;
      case "name":
        params.name = keyword;
        break;
      }

      await this.$store.dispatch("member/LOAD_MEMBERS", params);

      const listInfo = this.$store.state.member.listInfo;
      this.page.lastPage = listInfo.last_page;

      if (!this.showPopup) return [];

      const _users = this.$store.state.member.list;

      this.userList = _users.reduce((prev, curr) => {
        const user = { ...curr, disabled: this.disabledUserIds.includes(curr.id) };
        return [...prev, user];
      }, []);
    },
    handleChangePage(page) {
      this.page.current = page;
      this.loadUsers();
    },
    onClickUser (user) {
      if (!user.disabled) {
        if (this.selectUser === user) {
          this.onClickSelect()
        } else {
          this.selectUser = user;
        }
      }
    },
    onClickSelect() {
      this.showPopup = false;
      this.$emit("handleClickSelect", this.selectUser);
    },
    getFieldName(fields) {
      if (fields) {
        const names = fields.map((_f) => _f.field_name);
        return names.join(", ");
      } else return "";
    },
  },
};
</script>

<style lang="scss" scoped>
#alertUserSelectPopup::v-deep {
  .vs-popup {
    width: 90%;
  }

  @media screen and (min-width: theme("screens.xl")) {
    .vs-popup {
      width: 70%;
    }
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 2px solid #f9f9f9;

  th,
  td {
    font-size: 14px;
    text-align: center;

    padding: 10px;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  thead,
  tr {
    cursor: pointer;
    th:first-child,
    td:first-child {
      padding: 10px 0;
    }
  }

  tbody {
    tr:nth-child(2n -1) {
      background: #f9f9f9;
    }
  }

  tr.disabled {
    cursor: auto;
    color: #d3d3d3;
  }
  tr.active {
    background: #6670cb !important;
    color: #fff;
    font-weight: bold;
  }
}
</style>
